import { useEffect } from "react";
import { TID } from "@/constants/testIds";
import { useI18n } from "@/context/I18nContext";
import { useBudgetNotifier } from "@/lib/useBudgetNotifier";
import { useSharedData, invalidate } from "@/lib/useSharedData";
import { NeuTimeCard } from "@/components/dashboard/neu/NeuTimeCard";
import { NeuTodayCard } from "@/components/dashboard/neu/NeuTodayCard";
import { NeuCounters } from "@/components/dashboard/neu/NeuCounters";
import { NeuQuickActions } from "@/components/dashboard/neu/NeuQuickActions";
import { NeuBudgetDial } from "@/components/dashboard/neu/NeuBudgetDial";
import { NeuMood } from "@/components/dashboard/neu/NeuMood";
import { NeuSpendingBars } from "@/components/dashboard/neu/NeuSpendingBars";
import { NeuInsights } from "@/components/dashboard/neu/NeuInsights";
import { NeuActiveInstallments } from "@/components/dashboard/neu/NeuActiveInstallments";
import { NeuWeeklyTip } from "@/components/dashboard/neu/NeuWeeklyTip";
import { NeuAccountsDonut } from "@/components/dashboard/neu/NeuAccountsDonut";
import { NeuCashFlowForecast } from "@/components/dashboard/neu/NeuCashFlowForecast";
import { NeuQuickTabs } from "@/components/dashboard/neu/NeuQuickTabs";
import { NotificationBell } from "@/components/NotificationBell";

export default function Dashboard() {
  const { lang } = useI18n();
  const { data: summary } = useSharedData("dashboard-summary", "/dashboard/summary");
  useBudgetNotifier(lang);

  useEffect(() => {
    const onChange = () => { invalidate("dashboard-summary"); invalidate("recent-tx"); };
    const onVisible = () => { if (!document.hidden) onChange(); };
    window.addEventListener("malat:data-changed", onChange);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.removeEventListener("malat:data-changed", onChange);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return (
    <main data-testid={TID.dashboardRoot} className="neu-page">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 pt-[calc(env(safe-area-inset-top)+1.5rem)] pb-32 grid grid-cols-1 sm:grid-cols-5 gap-6 auto-rows-min">
        <div className="sm:col-span-5 relative"><NeuTimeCard /><NotificationBell /></div>
        <div className="sm:col-span-5"><NeuCounters summary={summary} /></div>
        <div className="sm:col-span-5"><NeuQuickActions /></div>
        <div className="sm:col-span-5"><NeuQuickTabs /></div>
        <div className="sm:col-span-5"><NeuWeeklyTip /></div>
        <div className="sm:col-span-5"><NeuTodayCard summary={summary} /></div>
        <div className="sm:col-span-5"><NeuAccountsDonut /></div>
        <div className="sm:col-span-5"><NeuCashFlowForecast summary={summary} /></div>
        <div className="sm:col-span-5"><NeuActiveInstallments /></div>
        <div className="sm:col-span-5"><NeuBudgetDial summary={summary} /></div>
        <div className="sm:col-span-2"><NeuMood summary={summary} /></div>
        <div className="sm:col-span-3"><NeuSpendingBars summary={summary} /></div>
        <div className="sm:col-span-5"><NeuInsights /></div>
      </div>
    </main>
  );
}
